var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('base-header',{staticClass:"pb-6",attrs:{"type":""}},[_c('notifications'),_c('div',{staticClass:"row card-wrapper py-4"},[_c('div',{staticClass:"col-xl-8 order-xl-1 mx-auto"},[_c('profile-form')],1)])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }